import React from 'react'

import Image from 'next/image'
import { getUrl } from '../utils/urls'
import { useNavigationData } from '@/src/context/NavigationContext'

const getImageComponent = (image, preview) => {
  if (preview && image?.url) return <Image src={image?.url} />
  return <Image src={image?.url} />
}
export const getFeatureCards = (featureCards = [], slugPrefix = '', preview) => {
  const { navigationItems } = useNavigationData()

  return featureCards?.map((item) => {
    const { image, action } = item
    return {
      ...item,
      id: item?.id,
      textTokens: {},
      image: image && getImageComponent(image, preview),
      action: action && {
        text: action?.title,
        small: false,
        url: preview
          ? '#'
          : getUrl({
              navItem: action,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })
      }
    }
  })
}
